import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getProductByHandle, Product } from '../../lib/shopify';
import { useCartStore } from '../../store/useCartStore';

export const ProductDetail = () => {
  const { handle } = useParams<{ handle: string }>();
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedVariant, setSelectedVariant] = useState<string>('');
  const addItem = useCartStore((state) => state.addItem);

  useEffect(() => {
    const fetchProduct = async () => {
      if (!handle) return;
      
      try {
        const data = await getProductByHandle(handle);
        setProduct(data);
        if (data.variants.edges.length > 0) {
          setSelectedVariant(data.variants.edges[0].node.id);
        }
      } catch (err) {
        setError('Failed to load product');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [handle]);

  if (loading) return <div>Loading product...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!product) return <div>Product not found</div>;

  const selectedVariantData = product.variants.edges.find(
    (edge) => edge.node.id === selectedVariant
  )?.node;

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-4">
          {product.images.edges.map((edge, index) => (
            <img
              key={index}
              src={edge.node.url}
              alt={edge.node.altText || product.title}
              className="w-full rounded-lg shadow-lg"
            />
          ))}
        </div>
        
        <div className="space-y-6">
          <h1 className="text-3xl font-bold">{product.title}</h1>
          
          <div className="text-xl text-gray-600">
            {selectedVariantData ? (
              <>
                {selectedVariantData.price.amount} {selectedVariantData.price.currencyCode}
              </>
            ) : (
              <>
                {product.priceRange.minVariantPrice.amount} {product.priceRange.minVariantPrice.currencyCode}
              </>
            )}
          </div>
          
          <div className="prose max-w-none">
            <p>{product.description}</p>
          </div>
          
          {product.variants.edges.length > 1 && (
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">
                Select Variant
              </label>
              <select
                value={selectedVariant}
                onChange={(e) => setSelectedVariant(e.target.value)}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              >
                {product.variants.edges.map((edge) => (
                  <option key={edge.node.id} value={edge.node.id}>
                    {edge.node.title}
                  </option>
                ))}
              </select>
            </div>
          )}
          
          <button
            onClick={() => {
              if (selectedVariantData) {
                addItem({
                  id: product.id,
                  variantId: selectedVariantData.id,
                  title: product.title,
                  price: selectedVariantData.price.amount,
                  image: product.images.edges[0]?.node.url,
                });
              }
            }}
            className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}; 